<template>
  <div class="py-4 space-y-6">
    <!-- Title -->
    <div class="text-center mb-6">
      <h1 class="text-xl font-bold text-foreground mb-2">
        {{ $t('report.client_mix_info.title') }}
      </h1>
      <p class="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
        {{ $t('report.client_mix_info.description') }}
      </p>
    </div>

    <!-- How to read — with mini visual example -->
    <div class="space-y-4">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.client_mix_info.how_to_read') }}
        </h2>
      </div>

      <!-- Mini stacked bar illustration -->
      <div class="rounded-lg p-3 mix-example-bg">
        <!-- Current bar -->
        <div class="flex items-center gap-2 mb-2">
          <span class="text-[10px] font-semibold text-muted-foreground w-14 shrink-0">
            {{ $t('report.client_mix_info.current_label') }}
          </span>
          <div class="flex h-4 rounded-full overflow-hidden flex-1">
            <div class="flex items-center justify-center text-[9px] font-bold text-white"
              style="background: #F59E0B; width: 35%">35%</div>
            <div class="flex items-center justify-center text-[9px] font-bold text-white"
              style="background: #06C8FF; width: 65%">65%</div>
          </div>
        </div>
        <!-- Previous bar -->
        <div class="flex items-center gap-2 mb-2">
          <span class="text-[10px] font-semibold text-muted-foreground/60 w-14 shrink-0">
            {{ $t('report.client_mix_info.previous_label') }}
          </span>
          <div class="flex h-4 rounded-full overflow-hidden flex-1 opacity-60">
            <div class="flex items-center justify-center text-[9px] font-bold text-white"
              style="background: #F59E0B; width: 42%">42%</div>
            <div class="flex items-center justify-center text-[9px] font-bold text-white"
              style="background: #06C8FF; width: 58%">58%</div>
          </div>
        </div>
        <!-- Shift pills -->
        <div class="flex items-center gap-2 mt-1">
          <div class="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold mix-pill-down">
            B2B -7pts
          </div>
          <div class="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[10px] font-bold mix-pill-up">
            B2C +7pts
          </div>
        </div>
      </div>

      <!-- Reading guide items -->
      <div class="space-y-3">
        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #F59E0B"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">B2B</span>
            <span class="text-xs text-muted-foreground"> / </span>
            <span class="w-2.5 h-2.5 rounded-full inline-block align-middle" style="background: #06C8FF"></span>
            <span class="text-xs font-semibold text-foreground"> B2C</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.client_mix_info.bars_explanation') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <div class="w-2.5 h-2.5 rounded shrink-0 mt-1 mix-shift-icon"></div>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.client_mix_info.shift_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.client_mix_info.shift_explanation') }}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup lang="ts">
// Content-only component — no props needed.
// Injected into a BottomSheet from CenterClientTypesReport.
</script>

<style scoped>
.mix-example-bg {
  background: rgba(107, 114, 128, 0.06);
  border: 1px solid rgba(107, 114, 128, 0.1);
}
:is(.dark *).mix-example-bg {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.mix-pill-up {
  background: rgba(22, 163, 74, 0.10);
  color: #16A34A;
}
.mix-pill-down {
  background: rgba(220, 38, 38, 0.10);
  color: #DC2626;
}
:is(.dark *).mix-pill-up {
  background: rgba(34, 197, 94, 0.15);
  color: #4ADE80;
}
:is(.dark *).mix-pill-down {
  background: rgba(248, 113, 113, 0.15);
  color: #F87171;
}

.mix-shift-icon {
  background: linear-gradient(135deg, #16A34A 50%, #DC2626 50%);
}
:is(.dark *).mix-shift-icon {
  background: linear-gradient(135deg, #4ADE80 50%, #F87171 50%);
}
</style>
